import { useMutation } from '@tanstack/react-query';
import { MutationKey } from '@shared/config';
import { companyApi } from '../companyApi';

export const useExportCompanies = () => {
  return useMutation({
    mutationKey: [MutationKey.EXPORT_VACANCY],
    mutationFn: async ({
      dateFrom,
      dateTo,
    }: {
      dateFrom: string | null;
      dateTo?: string | null;
    }) => {
      const response = companyApi.exportCompanies({ dateFrom, dateTo });
      return response;
    },
  });
};
